import { render, staticRenderFns } from "./GoodsDetailsCatalogReference.vue?vue&type=template&id=43389268"
import script from "./GoodsDetailsCatalogReference.vue?vue&type=script&lang=js"
export * from "./GoodsDetailsCatalogReference.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetailsCatalogReference.vue?vue&type=style&index=0&id=43389268&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports